import { IWidgetLayout } from "../../../manager/components/widgets-layout/widget-component/widget-component";

interface IScreen {
  name: string;
  id: string;
  layout: IWidgetLayout;
  alertcase_id: string;
  alert_name: string;
}

export function transformToBackendScreen(data: IScreen) {
  return {
    name: data.name,
    id: data.id,
    layout: JSON.stringify(data.layout),
    alertcase_id: data.alertcase_id,
    alert_name: data.alert_name
  };
}

export function transformFromBackendScreen(backendType: any) { // eslint-disable-line
  return {
    name: backendType.name,
    id: backendType.id,
    layout: JSON.parse(backendType.layout),
    alertcase_id: backendType.alertcase_id,
    alert_name: backendType.alert_name
  };
}
